import React from 'react';

import './CompanyIcon.scss';

export default class CompanyIcon extends React.PureComponent {
    constructor(props) {
        super();

        this.baseCls = 'component-Icons-CompanyIcon';
    }

    render() {
        const { baseCls } = this;
        return (
            <svg
                className={baseCls}
                width="42"
                height="42"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
            >
                <defs>
                    <path id={`${baseCls}__a`} d="M0 0h41.176v41.466H0z" />
                </defs>
                <g fill="none" fillRule="evenodd">
                    <path
                        fill="#FFF"
                        fillRule="nonzero"
                        d="M19.535 16.306h13.186v25.2H19.535z"
                    />
                    <path
                        fill="#FBF2C1"
                        fillRule="nonzero"
                        d="M9.767 2.471h13.919v3.706H9.767zM25.884 29.153h5.86v8.894h-5.86z"
                    />
                    <ellipse
                        fill="#EAC9EF"
                        fillRule="nonzero"
                        cx="39.216"
                        cy="34.489"
                        rx="2.564"
                        ry="2.594"
                    />
                    <ellipse
                        fill="#EAC9EF"
                        fillRule="nonzero"
                        cx="4.347"
                        cy="33.452"
                        rx="2.564"
                        ry="2.594"
                    />
                    <path
                        fill="#FBF2C1"
                        fillRule="nonzero"
                        d="M16.653 9.067h3.077v4.151h-3.077zM11.526 16.331h3.077v4.151h-3.077zM16.653 24.113h3.077v4.151h-3.077z"
                    />
                    <path
                        fill="#FFF"
                        fillRule="nonzero"
                        d="M7.814 6.424H21v34.588H7.814z"
                    />
                    <g transform="translate(.244 .247)">
                        <mask id={`${baseCls}__b`} fill="#fff">
                            <use xlinkHref={`#${baseCls}__a`} />
                        </mask>
                        <path
                            d="M11.443 20.972h1.328v-2.797h-1.328v2.797zm-.513 1.037h2.353a.515.515 0 0 0 .513-.518v-3.835a.516.516 0 0 0-.513-.519H10.93a.516.516 0 0 0-.513.519v3.835c0 .287.23.518.513.518zM16.531 20.972h1.328v-2.797h-1.328v2.797zm-.512 1.037h2.353a.516.516 0 0 0 .513-.518v-3.835a.516.516 0 0 0-.513-.519H16.02a.516.516 0 0 0-.513.519v3.835c0 .287.23.518.513.518zM11.443 28.539h1.328V25.74h-1.328v2.798zm-.513 1.037h2.353a.515.515 0 0 0 .513-.519v-3.834a.516.516 0 0 0-.513-.52H10.93a.516.516 0 0 0-.513.52v3.834c0 .287.23.519.513.519zM16.531 28.539h1.328V25.74h-1.328v2.798zm-.512 1.037h2.353a.516.516 0 0 0 .513-.519v-3.834a.516.516 0 0 0-.513-.52H16.02a.516.516 0 0 0-.513.52v3.834c0 .287.23.519.513.519zM11.443 35.713h1.328v-2.797h-1.328v2.797zm-.513 1.038h2.353a.516.516 0 0 0 .513-.519v-3.835a.516.516 0 0 0-.513-.518H10.93a.516.516 0 0 0-.513.518v3.835c0 .286.23.519.513.519zM16.531 35.713h1.328v-2.797h-1.328v2.797zm-.512 1.038h2.353a.516.516 0 0 0 .513-.519v-3.835a.516.516 0 0 0-.513-.518H16.02a.516.516 0 0 0-.513.518v3.835c0 .286.23.519.513.519zM11.443 13.503h1.328v-2.797h-1.328v2.797zm-.513 1.038h2.353a.515.515 0 0 0 .513-.519v-3.834a.516.516 0 0 0-.513-.52H10.93a.516.516 0 0 0-.513.52v3.834c0 .287.23.519.513.519zM16.531 13.503h1.328v-2.797h-1.328v2.797zm-.512 1.038h2.353a.516.516 0 0 0 .513-.519v-3.834a.516.516 0 0 0-.513-.52H16.02a.516.516 0 0 0-.513.52v3.834c0 .287.23.519.513.519z"
                            fill="#566D96"
                            mask={`url(#${baseCls}__b)`}
                        />
                        <path
                            d="M35.448 34.798c0-1.254 1.009-2.273 2.248-2.273 1.239 0 2.247 1.02 2.247 2.273 0 1.254-1.008 2.274-2.247 2.274-1.24 0-2.248-1.02-2.248-2.274zm2.248-5.222a.95.95 0 0 1 .944.955.95.95 0 0 1-.944.956.95.95 0 0 1-.944-.956.95.95 0 0 1 .944-.955zM21.971 15.173h11.272v-2.22H21.971v2.22zm10.513 25.255h-2.46v-9.897a.516.516 0 0 0-.513-.518h-4.647a.516.516 0 0 0-.512.518v9.897H21.97V16.211h10.513v24.217zm-7.107 0h3.621v-9.377h-3.621v9.377zM7.905 6.173h13.618V3.952H7.905v2.221zm.579 34.255h12.461V7.211H8.484v33.217zm4.215-37.514h3.904V1.038H12.7v1.876zm17.166 9h1.46v-2.09h-1.46v2.09zM1.152 34.798c0-1.254 1.009-2.273 2.247-2.273 1.24 0 2.248 1.02 2.248 2.273 0 1.254-1.008 2.274-2.248 2.274-1.238 0-2.247-1.02-2.247-2.274zM3.4 29.576a.95.95 0 0 1 .945.955.951.951 0 0 1-.945.956.95.95 0 0 1-.944-.956.95.95 0 0 1 .944-.955zm37.264 10.852h-2.454v-2.363a3.302 3.302 0 0 0 2.76-3.267c0-1.29-.735-2.408-1.803-2.954.307-.351.5-.807.5-1.313 0-1.099-.884-1.992-1.97-1.992-1.086 0-1.97.893-1.97 1.992 0 .505.193.961.5 1.313a3.317 3.317 0 0 0-1.803 2.954 3.302 3.302 0 0 0 2.76 3.267v2.363H33.51V16.211h.246a.516.516 0 0 0 .513-.519v-3.259a.516.516 0 0 0-.513-.519h-1.405v-2.61a.516.516 0 0 0-.513-.518h-2.486a.516.516 0 0 0-.513.519v2.61h-6.868V7.21h.065a.516.516 0 0 0 .513-.52V3.434a.516.516 0 0 0-.513-.519h-4.407V.52A.516.516 0 0 0 17.116 0h-4.93a.515.515 0 0 0-.513.519v2.395h-4.28a.516.516 0 0 0-.513.52v3.258c0 .286.23.519.513.519h.065v33.217H3.912v-2.363a3.302 3.302 0 0 0 2.76-3.267c0-1.29-.735-2.408-1.802-2.954.307-.351.5-.807.5-1.313 0-1.099-.884-1.992-1.97-1.992-1.087 0-1.97.893-1.97 1.992 0 .506.192.962.499 1.313a3.317 3.317 0 0 0-1.802 2.954 3.302 3.302 0 0 0 2.76 3.267v2.363H.513a.515.515 0 0 0-.513.52c0 .286.23.518.513.518h40.15a.516.516 0 0 0 .513-.519.516.516 0 0 0-.513-.519z"
                            fill="#2A4473"
                            mask={`url(#${baseCls}__b)`}
                        />
                    </g>
                </g>
            </svg>
        );
    }
}
